// "use-strict";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import back from "../assets/img/invoice/back.png";
import tamga from "../assets/img/invoice/tamga.png";
import mail from "../assets/img/invoice/fi_mail.png";
import logo from "../assets/img/invoice/mainLogo.jpg";
import pin from "../assets/img/invoice/fi_map-pin.png";
import divider from "../assets/img/invoice/Frame 1.png";
import phone from "../assets/img/invoice/u_phone-alt.png";
import { interSemiBold } from "../assets/font/base64/Inter-SemiBold";
import { timesNewRoman } from "../assets/font/base64/TimesNewRoman-normal";

const PAGE_WIDTH = 148.5;
const TBL_HEADER_STYLE = {
  fillColor: [255, 255, 255],
  textColor: [0, 0, 0],
  lineWidth: { left: 0, right: 0, bottom: 0.1 },
  lineColor: [0, 0, 0],
  font: "Times-New-Roman-Bold",
};
const ICON = 2.8;
const TBL_BODY_STYLE = {
  fillColor: [255, 255, 255],
  // textColor: [0, 0, 0],
  fontSize: 8,
  lineWidth: { left: 0, right: 0, bottom: 0.1 },
  // lineColor: [0, 0, 0],
};

const LOGO_WIDTH = 30;
const LOGO_HEIGHT = 8;
const SEAL_SIZE = 30;
const DIVIDER_H = 1;
const DIVIDER_W = 130;

export const PrintMerchantInvoice = (slips = [], billing = [], outputType) => {

  const doc = new jsPDF({ format: "a5", compress: true });
  doc.addFileToVFS("Times-New-Roman.ttf", timesNewRoman);
  doc.addFont("Times-New-Roman.ttf", "Times-New-Roman", "normal");
  doc.addFileToVFS("Times-New-Roman-Bold.ttf", interSemiBold);
  doc.addFont("Times-New-Roman-Bold.ttf", "Times-New-Roman-Bold", "normal");
  for (let i = 0; i < slips?.length; i++) {
    const data = slips?.[i];
    drawSlip({ doc, data, billing });
    if (i + 1 !== slips.length) doc.addPage();
  }
  if (!outputType) {
    const pdfData = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfData);
    var printWindow = window.open(pdfUrl, "_blank");
    const isLoaded = (printWindow.onload = function () {
      printWindow.print();
      URL.revokeObjectURL(pdfUrl);
      return true;
    });
    if (isLoaded) return true;
  }

  return doc?.output(outputType);
};

// ============= drawing pdf file ============= //
const drawSlip = ({ doc, data, billing }) => {
  const billingI = billing?.[0];
  const products = billingI?.[0]?.invoiceSub?.map((item) => {
    return [item?.serviceType || "-", item?.count || "-", item?.amount || "-"];
  });
  //logo
  doc.addImage(logo, "JPG", 10, 10, LOGO_WIDTH, LOGO_HEIGHT);

  let leftX = 10;
  let rightX = 110.5;
  let currentY = 10;

  doc.setFont("Times-New-Roman");
  doc.setFontSize(8);
  let txt = "Хэнд: ";
  doc.text(txt, leftX, currentY + 20);

  doc.setFontSize(10);
  // doc.setTextColor(255, 255, 255);
  doc.setFont("Times-New-Roman-Bold");
  txt = "Дөлгөөнбаяр.М";
  doc.text(txt, leftX, currentY + 25);

  doc.setFont("Times-New-Roman");
  doc.setFontSize(8);
  txt = "info@renew.mn";
  doc.text(txt, leftX + 5, currentY + 34);
  doc.addImage(mail, "PNG", 10, 42, ICON, ICON);

  txt = "9509-6446";
  doc.text(txt, leftX + 5, currentY + 39.5);
  doc.addImage(phone, "PNG", 10, 47, ICON, ICON);

  txt = "УБ, БЗД, 14-р хороо";
  doc.text(txt, leftX + 5, currentY + 44.5);
  doc.addImage(pin, "PNG", 10, 52, ICON, ICON);

  txt = "Эхлэх огноо:";
  doc.text(txt, rightX - 11.5, currentY + 34);
  txt = "Дуусах огноо:";
  doc.text(txt, rightX - 13, currentY + 39.5);
  txt = "Нэхэмжилсэн огноо:";
  doc.text(txt, rightX - 20.5, currentY + 44.5);

  txt = "2023/06/08 18:02:49";
  doc.text(txt, rightX + 5, currentY + 34);
  txt = "2023/09/22 15:15:36";
  doc.text(txt, rightX + 5, currentY + 39.5);
  txt = "2023/06/08 18:02:51";
  doc.text(txt, rightX + 5, currentY + 44.5);

  doc.setFont("Times-New-Roman");
  doc.setFontSize(12);
  txt = "НЭХЭМЖЛЭХ";
  doc.text(txt, PAGE_WIDTH / 2, 68, { align: "center" });

  doc.setFont("Times-New-Roman");
  doc.setFontSize(8);
  txt = "Дугаар: PP-22-121";
  doc.text(txt, PAGE_WIDTH / 2, 71.5, { align: "center" });

  const tblProducts = [...(products ?? [])];
  autoTable(doc, {
    theme: "grid",
    styles: { font: "Times-New-Roman-Bold", fontSize: 8 },
    startY: 75,
    startX: { align: "center" },
    tableWidth: PAGE_WIDTH - leftX * 2,
    margin: leftX,
    head: [
      [
        { content: "Үйлчилгээний төрөл", styles: { cellWidth: 40 } },
        { content: "Тоо хэмжээ", styles: { cellWidth: 40 } },
        { content: "НӨАТ-гүй дүн", styles: { cellWidth: 40 } },
      ],
    ],
    body: tblProducts,

    headStyles: TBL_HEADER_STYLE,
    bodyStyles: {
      ...TBL_BODY_STYLE,
      cellWidth: 40,
    },
  });

  currentY = doc.lastAutoTable.finalY;
  if (doc.lastAutoTable.finalY > 180) {
    doc.addPage();
    currentY = 10;
  }
  doc.setFontSize(8);
  doc.setFont("Times-New-Roman");
  txt = "Нийт дүн /НӨАТ-гүй/";
  leftX = leftX + 10;
  doc.text(txt, leftX, currentY + 8);
  txt = "НӨАТ 10%";
  doc.text(txt, leftX, currentY + 13);
  txt = "Үнийн өөрчлөлт";
  doc.text(txt, leftX, currentY + 18);
  txt = "Нийт дүн /НӨАТ-тай/";
  doc.text(txt, leftX, currentY + 23);

  rightX = rightX - 15;
  txt = "₮ 351,900";
  doc.text(txt, rightX, currentY + 8);
  txt = "₮ 35,190";
  doc.text(txt, rightX, currentY + 13);
  txt = "₮ -35,190";
  doc.text(txt, rightX, currentY + 18);
  txt = "₮ 387,090";
  doc.text(txt, rightX, currentY + 23);

  doc.addImage(back, "JPG", 0, 50, PAGE_WIDTH, PAGE_WIDTH);

  leftX = leftX - 10;
  txt = "Банк:";
  doc.text(txt, leftX, currentY + 40);
  txt = "Дансны нэр:";
  doc.text(txt, leftX, currentY + 45);
  txt = "Данс:";
  doc.text(txt, leftX, currentY + 50);
  txt = "Гүйлгээний утга:";
  doc.text(txt, leftX, currentY + 55);

  doc.setFont("Times-New-Roman-Bold");
  leftX = leftX + 30;
  txt = "Худалдаа Хөгжлийн Банк";
  doc.text(txt, leftX, currentY + 40);
  txt = "Пик Пак ХХК";
  doc.text(txt, leftX, currentY + 45);
  txt = "499042000";
  doc.text(txt, leftX, currentY + 50);
  txt = "PP-23-01434";
  doc.text(txt, leftX, currentY + 55);

  doc.addImage(tamga, "JPG", 100, currentY + 35, SEAL_SIZE, SEAL_SIZE);

  leftX = leftX - 25;
  doc.setFont("Times-New-Roman");
  doc.setFontSize(8);
  txt = "finance@pickpack.mn";
  doc.text(txt, leftX, currentY + 72);
  doc.addImage(mail, "PNG", 10, currentY + 70, ICON, ICON);

  txt = "7777-6090";
  doc.text(txt, leftX, currentY + 77.5);
  doc.addImage(phone, "PNG", 10, currentY + 75, ICON, ICON);

  txt = "УБ, СБД, 1-р хороо, Централ Парк Тауэр оффис, 14 давхар";
  doc.text(txt, leftX, currentY + 82.5);
  doc.addImage(pin, "PNG", 10, currentY + 80, ICON, ICON);

  doc.addImage(divider, "JPG", 10, currentY + 110, DIVIDER_W, DIVIDER_H);
};
